"use client";
import Link from "next/link";

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.55, ease: [0.16, 0.84, 0.44, 1], delay: i * 0.08 } })
};

export default function About() {
  return (
    <section id="about" className="relative py-20 sm:py-24">
      {/* Soft background ring */}


      <div className="relative max-w-5xl mx-auto px-6 md:px-10 text-center">
        <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-brand-gradient"><span className="text-white font-thin">About</span> Youth Innovation Academy</h2>
        <p className="mt-4 text-base md:text-lg text-white/80 leading-relaxed max-w-3xl mx-auto">
          We run short, mentor‑led programs where you learn by building. In 2 months, you’ll ship portfolio‑ready work and gain the confidence to take on real opportunities.
        </p>
       
        <Link href="/about"  className="mt-10 inline-block">
          <button className="rounded-full px-6 h-11 text-sm font-semibold text-white bg-brand-gradient shadow shadow-brand-glow hover:brightness-110 cursor-pointer hover:bg-brand-gradient/50  transition-colors delay-200  focus:outline-none focus-visible:ring-2 focus-visible:ring-brand">
            See Details
          </button>
        </Link>
      </div>
    </section>
  );
}